"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.I18nContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18n = _interopRequireWildcard(require("./i18n"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const I18nContext = _react.default.createContext('');

exports.I18nContext = I18nContext;

class I18nProvider extends _react.default.Component {
  constructor(props) {
    super(props);

    _i18n.default.setLocaleLoaders(this.props.localeLoaders);

    this.state = {
      locale: '',
      firstLoaded: false
    };
  }

  async loadLang(lang) {
    await _i18n.default.setLocale(lang || (0, _i18n.getDefaultLanguage)());
    this.setState({
      locale: lang,
      firstLoaded: true
    });
  }

  componentDidMount() {
    this.loadLang(this.props.lang);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.lang !== this.props.lang) {
      this.loadLang(nextProps.lang);
      return false;
    }

    if (nextState.locale !== this.state.locale) return true;
    return false;
  }

  render() {
    if (!this.state.firstLoaded) return null;
    return /*#__PURE__*/_react.default.createElement(I18nContext.Provider, {
      value: this.state.locale
    }, this.props.children);
  }

}

exports.default = I18nProvider;